<div class="footer flex">
  <div class="flex-auto flex items-center container">
    <div class="font-medium ltr:ml-4 rtl:mr-4 hidden sm:block">
      Vex - Angular 14+ Material Design Admin Template - Save 100s of hours
      designing and coding
    </div>
  </div>
</div>
